// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function SafeIcon(Props) {
  var circle_fill_color = Props.circle_fill_color;
  var path_fill_color = Props.path_fill_color;
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("circle", {
                  cx: "10",
                  cy: "10",
                  fill: circle_fill_color,
                  r: "10"
                }), React.createElement("path", {
                  clipRule: "evenodd",
                  d: "M9.86227 6.70024C10.0401 6.43351 10.2811 6.21481 10.5638 6.06358C10.8464 5.91234 11.1621 5.83325 11.4827 5.83333H11.5864C11.7278 5.83331 11.8675 5.8641 11.9958 5.92355C12.1241 5.983 12.2379 6.06969 12.3293 6.17758C12.4207 6.28547 12.4875 6.41198 12.525 6.54831C12.5626 6.68464 12.57 6.82751 12.5467 6.96699L12.2488 8.75388H13.4073C13.6234 8.75386 13.8367 8.80179 14.032 8.89419C14.2273 8.9866 14.3996 9.12119 14.5366 9.28825C14.6736 9.45532 14.7718 9.65069 14.8242 9.8603C14.8765 10.0699 14.8817 10.2885 14.8394 10.5004L14.2553 13.4209C14.1891 13.752 14.0102 14.0499 13.7491 14.264C13.488 14.478 13.1608 14.595 12.8232 14.595H7.29365C6.90636 14.595 6.53493 14.4411 6.26108 14.1673C5.98722 13.8934 5.83337 13.522 5.83337 13.1347V9.24064C5.83337 9.11154 5.88466 8.98773 5.97594 8.89645C6.06723 8.80516 6.19104 8.75388 6.32013 8.75388H8.23309C8.31321 8.75389 8.39209 8.73413 8.46274 8.69634C8.53338 8.65855 8.59361 8.60392 8.63807 8.53727L9.86227 6.70024ZM7.78041 9.72739H6.80689V13.1347C6.80689 13.2638 6.85817 13.3876 6.94946 13.4789C7.04074 13.5702 7.16455 13.6215 7.29365 13.6215H7.78041V9.72739Z",
                  fill: path_fill_color,
                  fillRule: "evenodd"
                }));
}

var make = SafeIcon;

export {
  make ,
  
}
/* react Not a pure module */
